import TagBar from './TagBar';

export {
  TagBar
};



/** WEBPACK FOOTER **
 ** ./src/modules/tags/components/index.js
 **/